export default {
  path: 'balance',
  name: 'balance',
  component: () => import('@/pages/balance/BalanceIndex'),
  meta: { title: '账号余额' }
}
